import { lazy, Suspense } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AppRoutes } from './routes/AppRoutes'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Branch staff leave a tab open all day; refetching on every window focus
      // would hammer the API for no benefit on data that changes by the minute.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      // The api() wrapper already refreshes once and retries on a 401. Retrying
      // an authorisation failure again here would just repeat a refused request.
      retry: 1,
    },
  },
})

// D-146: the supplier portal is its own app, loaded on its own — a supplier's browser never
// fetches or runs the staff app, and a staff session is never restored at /supplier.
const SupplierPortalApp = lazy(() => import('./supplier/SupplierPortalApp'))

export default function App() {
  if (window.location.pathname === '/supplier' || window.location.pathname.startsWith('/supplier/')) {
    return (
      <Suspense fallback={<div className="min-h-screen bg-dpl-bg" aria-busy="true" />}>
        <SupplierPortalApp />
      </Suspense>
    )
  }

  return (
    <QueryClientProvider client={queryClient}>
      <AppRoutes />
    </QueryClientProvider>
  )
}
